export interface IConfig {
  formId: string;
  appUrl: () => string;
  serviceUrl: () => string;
  portalUrl: () => string;
  usersUrl: () => string;
  graphqlUrl: () => string;
  auth0Domain: () => string;
  auth0ClientId: () => string;
  auth0Audience: () => string;
  responsiveBreakPoint: string;
  sentryUrl: string;
  timeout: number;
  appType: string;
  cpayScope: Array<string>;
  authenticatePasswordlessScope: Array<string>;
}

export interface CpayResponse {
  responseText: string;
  token: string;
  cardHolder: string;
  cardNumber: string;
  cardType: string;
  cardExpiry: string;
}

export interface PaymentMethod {
  type: PaymentMethodType;
}

export interface BankAccount extends PaymentMethod {
  accountBsb: string;
  accountLast4: string;
  accountName: string;
}

export interface CreditCard extends PaymentMethod {
  cardType: PaymentCardType;
  maskedCardNumber: string;
  cardExpiry: string;
}

export enum PaymentMethodType {
  CREDIT_CARD = 'CREDIT_CARD',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export enum PaymentCardType {
  VISA = 'VISA',
  MasterCard = 'MasterCard',
}

export interface RemoteIdAuth {
  remoteId: string;
  authCode?: string;
  scope?: Array<string>;
}

export interface Identity {
  scope: Array<string>;
  accessToken: string;
  refreshToken: string;
  // Only the passwordless flow's identity carries a `user` field (see isIdentity below, and
  // adminLoginSuccess/persistIdentity in actions/index.tsx, which never sets one) — optional here
  // to match what's actually stored for an admin-provider identity.
  user?: Record<string, any>;
  needRefresh?: boolean;
  provider?: 'admin' | 'passwordless';
}

export const isIdentity = (object: any): object is Identity => {
  return Boolean(object && object.user && object.scope && object.accessToken && object.refreshToken && object);
};

export type Page = {
  pageName: string;
  page: any;
};
